// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27gW5","footer":"styles_footer__CFgEX"};